
//# sourceMappingURL=maps/scripts.js.map

(function($) {



	$(document).ready(function(){

		if($('#block-pilotstudytopblock').length > 0) {
			$(window).on('scroll', function() {
				console.log('Distance from window top: ', window.scrollY + 'px');
				if(window.scrollY >= 830) {
					$('#block-pilotstudytopblock .topic-menu').addClass('sticky');
				} else if(window.scrollY < 830) {
					$('#block-pilotstudytopblock .topic-menu').removeClass('sticky');
				}
			});

			$('#block-pilotstudytopblock .topic-menu .menu-button').on('click', function(e) {
				$('#block-pilotstudytopblock .topic-menu').toggleClass('expanded');
			});
		}

		$('#menu-mobile').on('click', function() {
			$("#block-website-branding>.site-logo").toggleClass('menu-active');
			$("#block-website-main-menu").toggleClass('menu-active');
			$(".plus").toggle();
			$(".cross").toggle();
		});

		$('.path-frontpage .block-views-blocknews-front2-block-1 .view-news-front2 .view-content').slick({
			dots: true,
			arrows: false, 
			initialSlide: 0,
			centerMode: false,
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 10000,
			pauseOnHover: true,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					infinite: true,
					dots: true
					}
				}
			]
		});

		$('.block-views-blocktestimonials-block-1 .view-testimonials .view-content').slick({
			dots: true,
			arrows: false, 
			initialSlide: 0,
			centerMode: false,
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 10000,
			pauseOnHover: true,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					infinite: true,
					dots: true
					}
				}
			]
		});
		  
		$('.arrow-left').click(function(){
			$('.path-photo .field--name-field-media-images').slick('slickPrev');
		});
		
		$('.arrow-right').click(function(){
			$('.path-photo .field--name-field-media-images').slick('slickNext');
		});

		$('#block-views-block-photo-gallery-block-1 .field--name-field-media-images').slick({
			arrows: false, 
			initialSlide: 0,
			slidesToShow: 1,
			infinite: true,
			slidesToScroll: 1,
			centerMode: true,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						dots: false
					}
				}
			]
		})
		
		$('.arrow-left').click(function(){
			$('#block-views-block-photo-gallery-block-1 .field--name-field-media-images').slick('slickPrev');
		})
		
		$('.arrow-right').click(function(){
			$('#block-views-block-photo-gallery-block-1 .field--name-field-media-images').slick('slickNext');
		})


		$('.field--name-field-media-images .field__item').on('click', function(e) {
			var index = $(e.target).parent().index();
			$("#block-views-block-photo-gallery-block-1").css('visibility','visible');
			$('#block-views-block-photo-gallery-block-1 .field--name-field-media-images').slick('slickGoTo', index, true);
			
			$(document).mouseup(function(e) 
			{
				var container = $("#block-views-block-photo-gallery-block-1 .views-row .field-content");
				var container2 = $("#block-views-block-photo-gallery-block-1 .views-field-nothing .slick-buttons");
				// if the target of the click isn't the container nor a descendant of the container
				if ((!container.is(e.target) && container.has(e.target).length === 0) && (!container2.is(e.target) && container2.has(e.target).length === 0))
				{
					$("#block-views-block-photo-gallery-block-1").css('visibility','hidden');
				}

				var backToGallery = $("#block-views-block-photo-gallery-block-1 .views-field-nothing .slick-buttons .grid").click(function(){
					$("#block-views-block-photo-gallery-block-1").css('visibility','hidden');
				});
			});
		});
		
		$(window).resize(function(){
			$('#block-views-block-photo-gallery-block-1 .field--name-field-media-images').slick('resize');
		});
	});

	$(document).keyup(function(e) {
		if (e.keyCode === 27) $("#block-views-block-photo-gallery-block-1").css('visibility','hidden');   // esc
	});
})(jQuery);